import { defaultSelectedCart } from "./state";

export function setCart(state, cart) {

  if (cart.documents_products) {
    cart.documents_products.map((dp, index) => {
      dp.edit_discount_value = false;
    });
  }

  state.cart = cart;
  state.cartInitial = cart;
}

export function setCartItems(state, items) {
  state.cart.items = items;
}

export function setPathPdf(state, path) {
  console.log(path);
  state.pathPdf = path;
}

export function setInformation(state, information) {
  state.cart.information = information;
}

export function cartError(state, payload) {
  state.error = true;
  state.errorMessage = payload;
}

export function setTotal(state, total) {
  state.total = total;
}

export function setPdf(state, pdf) {
  state.pdf = pdf;
}

export function addItemCart(state, item) {
  let documents_products = [];

  if (state.cart.documents_products) {
    documents_products = state.cart.documents_products
  }

  documents_products.push(item)

  state.cart.documents_products = documents_products;
}

export function deleteItemCart(state, item) {
  let documents_products = [];

  documents_products = JSON.parse(
    JSON.stringify(state.cart.documents_products)
  );

  let index = documents_products.findIndex(dp => dp.id == item.id);

  if (index >= 0) {
    documents_products.splice(index, 1);
  }

  state.cart.documents_products = documents_products;
}

export function setLastCart(state, last_cart) {
  state.last_cart = last_cart;
}

/**
 * Asigna un valor a la variable de state selected_model
 * @param state
 * @param selected_model
 */
export function setSelectedModel(state, selected_model) {
  state.selected_model = selected_model;
}

export function setLockAdd(state, lockAdd) {
  state.lockAdd = lockAdd
}

export function setLockPromotions(state, lockPromotions) {
  state.lockPromotions = lockPromotions
}
export function serDpNewPrice(state, dps_new_price) {
  state.cart.documents_products.map(dp => {
    let updated_price = dps_new_price.find(dp_np => dp_np == dp.id)
    if (updated_price) dp._rowVariant = 'warning'
  })
}

// Pedido Sugerido AI / Pedido Ideal

export function setResumeAi(state, resume_csv) {
  state.resume_ai = resume_csv;
}

export function setSuggestedProductPurchaseDaysQuantities(state, ids) {
  state.suggestedProductPurchaseDaysQuantities = ids;
}

export function setSuggestedProductSeasonality(state, ids) {
  state.suggestedProductSeasonality = ids;
}

export function setSuggestedProductLastSale(state, data) {
  state.suggestedProductLastSale = data;
}

export function getSuggestedProductSalesCompany(state, data) {
  state.suggestedProductSalesCompany = data;
}

export function setResumeProductAi(state, data) {
  state.resumeProductAi = data;
}

export function setResumeProductQuantityAi(state, data) {
    state.resumeProductQuantityAi = data;
}

export function cartErrorRevalueDocument (state, data) {
	state.error_revalue_document = data;
}

export function setCartSuggested(state, cart) {
  state.cart_suggested = cart;
}

export function resetCartSuggested(state) {
  state.cart_suggested = {
    documents_product: [],
    documents_information: {
      price_list: "",
    },
    price_lists: [],
  };
}

export function setCartSuggestedProducts(state, data) {
  state.cartSuggestedProducts = data;
}

export function resetSuggestedProductSelectedLocalStorage(state) {
  localStorage.removeItem("suggested_product_selected_brands");
  localStorage.removeItem("suggested_product_selected_families");
  localStorage.removeItem("suggested_product_selected_categories");
}

export function setBrandSublineCategoryRelations(state, data) {
  const relations = [
      ...new Map(
          state.cart_suggested.documents_products
              .map(item => ({
                  brand_id: (item.product || {}).brand_id,
                  subline_id: (item.product || {}).subline_id,
                  category_id: (item.product || {}).category_id
              }))
              .filter(item =>
                  item.brand_id &&
                  item.subline_id &&
                  item.category_id
              )
              .map(item => [
                  `${item.brand_id}-${item.subline_id}-${item.category_id}`,
                  item
              ])
      ).values()
  ];

  state.brandSublineCategoryRelations = relations;
}


// WEBPACK FOOTER //
// ./src/b2b/modules/cart/mutations.js